<template>
    <div id="apart_main">
        <div class="apart-top flex-row flex-row-between ">
            <div class="flex-row t-p-l-25 cursor_1" @click="goBack">
                <img class="back-img" :src="require('@/assets/image/icon_right.png')">
                <span class="apart-top-title">
                    返回
                </span>
            </div>
            <div class="tabs">
                <advanced-nav :nav-items="navItems" :initialIndex="initialIndex" indicator-type="fixed"
                    :fixed-width="21" indicator-position="center" @nav-change="navChange" />
            </div>
            <div class="add-btn t-p-r-25" @click="openTip">
                <img class="add-icon cursor_1" width="19" height="19" :src="require('@/assets/image/apart/notes.png')">
                <span class="notes-text">
                    参考格式
                </span>
            </div>
        </div>
        <main class="center-main">
            <!-- 长文本输入 -->
            <div v-if="initialIndex === 0" class="textarea-div">
                <div class="textarea">
                    <textarea v-model="text" placeholder="请严格按照“参考格式”粘贴或输入您需要拆解的内容。"></textarea>
                </div>
            </div>
            <!-- 文本上传 -->
            <div class="update-txt" v-else>
                <div @click="triggerFileInput" class="update-border">
                    <div v-if="!file" class="update">
                        <img src="@/assets/image/apart/update_apart.png" width="42" height="42"
                            class="update_apart-img" />
                        <p class="notes_text">
                            <!-- <img src="@/assets/image/apart/notes1.png" width="15" height="15" class="notes1-img" /> -->
                            <span>点击上传TXT文件，大小建议不超过6M</span>
                        </p>
                    </div>
                    <div v-else class="update">
                        <img src="@/assets/image/file/txt.png" width="42" height="42" class="update_apart-img" />
                        <p class="notes_text">
                            <span>{{ file.name }}</span>
                        </p>
                    </div>
                </div>
                <input type="file" ref="fileInput" accept="text/plain" class="file-input" @change="handleFileChange">
            </div>
            <div class="tj">
                <el-button v-if="initialIndex === 0" @click="textSubmitClick" class="tj-btn"><span>提交</span></el-button>
                <el-button v-else-if="initialIndex === 1" @click="updateSubmitClick"
                    class="tj-btn"><span>提交</span></el-button>
            </div>
        </main>
        <!-- 拆书流程 -->
        <footer class="footer-main">
            <div class="footer-img">
                <img src="@/assets/image/apart/apart_footer1.png" />
            </div>
        </footer>
        <loadingStatus v-if="loading"></loadingStatus>
        <tipPopup ref="tipPopup" name="重生归来之占山为王"></tipPopup>
        <popup ref="delPopup" @confirm="confirm"></popup>
    </div>
</template>
<script>
import api from '@/api/apart';
import iconvLite from 'iconv-lite';
import chardet from 'chardet';
import tipPopup from '@/components/tip_popup.vue'
import AdvancedNav from "@/components/dongeb/tabs.vue"
import loadingStatus from '@/components/loading_status.vue' //加载效果
import popup from '@/components/dongeb/popup.vue';
export default {
    components: {
        AdvancedNav, loadingStatus, popup, tipPopup
    },
    data() {
        return {
            navItems: ['长文本输入', '上传文档'],
            initialIndex: 0,
            file: null,
            loading: false,
            promptLoading: true,
            errorMessage: '',
            successMessage: '',
            text: '',//多文本框
            maxFileSize: 6 * 1024 * 1024, // 6MB
            allowedTypes: ['text/plain'], // 允许的MIME类型
            updateTxtForm: {
                title: "",
                id: 0,
                chapters: []
            }
        }
    },
    methods: {
        handleClose() {
            this.promptLoading = false
        },
        goBack() {
            if (this.text) {
                this.$refs.delPopup.openPrompt(8)
            } else {
                this.$emit('goBack', 'list')
            }

        },
        confirm() {
            this.$emit('goBack', 'list')
        },
        currentNum(val) {
            this.queryParams.pageNum = val
        },
        handleAdd() {
            // this.$emits('click', 'add');
            this.promptLoading = true
        },
        navChange(i) {
            this.initialIndex = i
        },
        triggerFileInput() {
            this.$refs.fileInput.click()
        },
        //打开格式提示
        openTip() {
            this.$nextTick(() => {
                this.$refs.tipPopup.openPopup();
            })

        },
        async handleFileChange(e) {
            const files = e.target.files
            if (files.length === 0) return
            this.file = files[0]
            // 验证文件类型
            if (!this.allowedTypes.includes(this.file.type)) {
                this.file = null
                this.$refs.fileInput.value = ''
                this.$message.warning('必需是TXT文件类型')
                return
            }
            // 验证文件大小
            if (this.file.size > this.maxFileSize) {
                this.errorMessage = `文件大小超过${this.maxFileSize / 1024 / 1024}MB限制`
                this.$message.warning(`文件大小超过${this.maxFileSize / 1024 / 1024}MB限制`)
                this.file = null
                this.$refs.fileInput.value = ''
                return
            }
        },
        //复制文字提交
        textSubmitClick() {
            try {
                if (this.text) {
                    this.loading = true
                    this.parseTxtToJson(this.text)
                    if (this.updateTxtForm.title) {
                        // 分批切割数组
                        const dataList = this.updateTxtForm.chapters; // 章节列表list数据
                        const batches = []; //数据拆分批量上传
                        const BATCH_SIZE = 100;//分100条数据
                        for (let i = 0; i < dataList.length; i += BATCH_SIZE) {
                            batches.push(dataList.slice(i, i + BATCH_SIZE));
                        }
                        api.init({ title: this.updateTxtForm.title }).then(async res => {
                            if (res.code === 200) {
                                for (let index = 0; index < batches.length; index++) {
                                    let data = {
                                        id: res.data,
                                        chapters: batches[index]
                                    }
                                    try {
                                        // console.log('执行遍历batches=', index)
                                        let result = await api.updateTxt(data)
                                        if (result.code === 200) {
                                            // console.log('当前分组=', index)
                                            if (index === batches.length - 1) {
                                                this.$router.replace({ path: '/apartUnpackManage', query: { id: res.data } });
                                                return;
                                            }
                                        } else {
                                            this.$message.error(result.msg);
                                            this.loading = false
                                        }
                                    } catch {
                                        this.$message.error('文件上传失败');
                                        throw Error('文件上传失败')
                                    }
                                }
                            }
                        }).finally(() => {
                            setTimeout(() => {
                                this.loading = false
                            }, 1000);
                        })

                    } else {
                        setTimeout(() => {
                            this.loading = false
                        }, 1000);
                    }
                } else {
                    this.$message.warning('请填写复制TXT文本')
                }
            } catch {
                setTimeout(() => {
                    this.loading = false
                }, 1000);
            }
        },
        //文件上传
        updateSubmitClick() {
            try {
                const file = this.file
                if (!file) {
                    this.$message.warning('请上传TXT文本')
                    return
                }
                this.loading = true
                const reader = new FileReader()
                reader.onload = (e) => {
                    const buffer = new Uint8Array(e.target.result);
                    // 1. 检测编码
                    const detectedEncoding = chardet.detect(buffer);
                    // console.log('detectedEncoding=',detectedEncoding);
                    // console.log('文件的编码格式=',detectedEncoding);
                    if (!iconvLite.encodingExists(detectedEncoding)) {
                        this.$message.error(`TXT文本不支持编码: ${detectedEncoding},请修改类型后重新上传`);
                        this.file = null
                        this.loading = false
                        return
                    }
                    const content = iconvLite.decode(buffer, detectedEncoding);
                    // console.log('编码过后的文本=',content);
                    this.parseTxtToJson(content)
                    if (this.updateTxtForm.title) {
                        // 分批切割数组
                        const dataList = this.updateTxtForm.chapters; // 章节列表list数据
                        const batches = []; //数据拆分批量上传
                        const BATCH_SIZE = 100;//分100条数据
                        for (let i = 0; i < dataList.length; i += BATCH_SIZE) {
                            batches.push(dataList.slice(i, i + BATCH_SIZE));
                        }
                        api.init({ title: this.updateTxtForm.title }).then(async res => {
                            if (res.code === 200) {
                                // 使用for循环替代forEach，确保顺序执行
                                for (let index = 0; index < batches.length; index++) {
                                    let data = {
                                        id: res.data,
                                        chapters: batches[index]
                                    }
                                    try {
                                        // console.log('执行遍历batches=', index)
                                        let result = await api.updateTxt(data)
                                        if (result.code === 200) {
                                            // console.log('当前分组=', index)
                                            if (index === batches.length - 1) {
                                                this.$router.replace({ path: '/apartUnpackManage', query: { id: res.data } });
                                                return;
                                            }
                                        } else {
                                            this.$message.error(result.msg);
                                            this.loading = false
                                        }
                                    } catch {
                                        this.$message.error('文件上传失败');
                                        throw Error('文件上传失败')
                                    }
                                }

                            }
                        }).finally(() => {
                            setTimeout(() => {
                                this.loading = false
                            }, 1000);
                        })

                    } else {
                        setTimeout(() => {
                            this.loading = false
                        }, 1000);
                    }
                }
                reader.onerror = (error) => {
                    this.$message.error('文件读取错误:', error)
                    setTimeout(() => {
                        this.loading = false
                    }, 1000);
                }
                reader.readAsArrayBuffer(file)
            } catch {
                setTimeout(() => {
                    this.loading = false
                }, 1000);
            }
        },
        // 解析内容
        parseTxtToJson(txtContent) {
            const lines = txtContent.split('\n').filter(line => line.trim() !== '');
            // console.log(lines)
            if (lines.length === 0) {
                this.$message.error('内容为空');
                return;
            }
            // 存放作品名和章节
            const chapters = [];
            // 提取作品名
            const workName = lines[0].trim();
            if (workName.length > 150) {
                this.$message.error('作品名不能超过150字');
                return;
            }

            let currentChapter = null;
            const chapterTitles = new Set(); // 用于检测重复标题

            for (let i = 1; i < lines.length; i++) {
                let line = this.clearZeroWidthText(lines[i].trim())
                if (line) {
                    line = this.removeHtmlTags(line)
                    //移除星号井号
                    line = line.replace(/\*+/g, '').replace(/#+/g, '')
                }
                // 检测是否是章节标题行（以"第X章"开头）
                if (line.match(this.titleContentFormat())) {
                    // 验证标题长度
                    if (line.length > 100) {
                        this.$message.error(`章节标题"${line}"超过100字限制`);
                        return;
                    }

                    // 检查是否重复
                    // if (chapterTitles.has(line)) {
                    //     this.$message.error(`发现重复章节标题: ${line}`);
                    //     return;
                    // }
                    // chapterTitles.add(line);

                    // 保存前一章（如果有）
                    if (currentChapter) {
                        // 验证内容长度
                        if (currentChapter.content.length > 10000) {
                            this.$message.error(`章节"${currentChapter.title}"内容超过1万字限制`);
                            return;
                        }
                        if (currentChapter.content.length === 0) {
                            // this.$message.error(`章节"${currentChapter.title}"内容不能为空`);
                            // return;
                            continue
                        }
                        // console.log('进行下一个不会在执行下来');
                        chapters.push(currentChapter);
                    }

                    // 开始新章节
                    currentChapter = {
                        chapter: chapters.length + 1, // 章节序号自动递增
                        title: line,
                        content: ''
                    };
                } else if (currentChapter) {
                    // 添加内容到当前章节
                    if (currentChapter.content) {
                        currentChapter.content += '\n' + line;
                    } else {
                        currentChapter.content = line;
                    }

                } else {
                    // 在第一个章节标题前的内容视为错误
                    this.$message.error('在作品名后没有找到有效的章节标题');
                    // throw new Error('在作品名后没有找到有效的章节标题')
                    return;
                }
            }

            // 添加最后一章
            if (currentChapter) {
                if (currentChapter.content.length > 10000) {
                    this.$message.error(`章节"${currentChapter.title}"内容超过1万字限制`);
                    // throw new Error(`章节"${currentChapter.title}"内容超过5万字限制`)
                    return;
                }
                chapters.push(currentChapter);
            }
            if(!chapters.length){
                 this.$message.error(`未检测到标题和内容`);
                 return;
            }
            this.updateTxtForm.title = workName
            this.updateTxtForm.chapters = chapters
            return this.updateTxtForm;
        }

    }
}
</script>
<style lang="scss" scoped>
p {
    margin: 0;
}

.list-btn {
    color: #333333;
}

.btn-icon {
    width: 17px;
    height: 17px;
}

.btn-icon,
.btn-text {
    vertical-align: middle;
    font-family: PingFang SC, PingFang SC;
}

.btn-text {
    margin-left: 2px;
}

.info-right {
    float: right;
    padding-right: 1%;
}

.apart-title {
    padding-top: 33px;
    padding-bottom: 19px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 17px;
    color: #111111;
    line-height: 17px;
    text-align: left;
    font-style: normal;
    text-transform: none;
}

.apart-info {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 17px;
    color: #FF8E0D;
    line-height: 17px;
    text-align: left;
    font-style: normal;
    text-transform: none;
}

.apart-item {
    margin: 0 25px;
    height: 106px;
    position: relative;

    &::before {
        content: " ";
        position: absolute;
        bottom: 0;
        height: 1px;
        width: 100%;
        background-color: #E6EBF0;
    }
}

.empty-list {
    width: 100%;
    height: 92%;
    background-color: #FFFFFF;
    display: flex;
    flex-direction: column;
    /* 子元素垂直排列 */
    justify-content: center;
    /* 整体垂直居中 */
    align-items: center;
}


.list-btn:hover {
    color: var(--tech-primary);
}



.add-btn {
    height: 100%;
    font-size: 16px;
    display: flex;
    align-items: center;
}

.notes-text {
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 17px;
    color: #68482E;
    line-height: 1;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-left: 2px;
    cursor: pointer;
}

.apart-list {
    width: 100%;
    height: 82%;
    background-color: #FFFFFF;
}

.apart-top {
    width: 100%;
    height: 77px;
    background-color: #FFFFFF;
    position: relative;

    &::before {
        content: " ";
        position: absolute;
        bottom: 0;
        height: 1px;
        width: 100%;
        background-color: #E6EBF0;
    }

    .back-img {
        display: block;
        margin-top: 2px;
    }

    .apart-top-title {
        height: 19px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: bold;
        font-size: 19px;
        color: #111111;
        line-height: 19px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        margin-left: 4px;
    }
}

#apart_main {
    flex: 1;
    margin: 16px 0 0 20px;
    background-color: #FFFFFF;
    box-shadow: 0px 0 8px 0px rgba(117, 53, 0, 0.06);
    border-radius: 8px 8px 0 0;
    overflow: auto;
    position: relative;
    display: flex;
    flex-direction: column;
}

.center-main {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin: 25px 32px 0 32px;

    // border: 1px solid red;
    .textarea-div {
        flex: 1;
        display: flex;
        flex-direction: column;

        .textarea {
            flex: 1;
            // border: 1px solid green;
        }
    }

    .update-txt {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;

        .update-border {
            width: 352px;
            height: 184px;
            position: relative;
            background-image: url(@/assets/image/apart/update_border.png);
            background-size: cover;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .update {
            position: absolute;
            text-align: center;
            padding: 0 20px;
            cursor: pointer;

            .notes_text {
                display: flex;
                align-items: center;
                margin-top: 21px;
                cursor: pointer;

                span {
                    height: 15px;
                    font-family: Microsoft YaHei, Microsoft YaHei;
                    font-weight: 400;
                    font-size: 15px;
                    color: #333333;
                    line-height: 15px;
                    text-align: left;
                    cursor: pointer;
                }
            }
        }
    }

    .tj {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100px;

        .tj-btn {
            width: 167px;
            height: 33px;
            background: var(--tech-primary);
            border-radius: 8px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: none;
            cursor: pointer;

            &:hover {
                opacity: 0.8;
            }

            span {
                font-family: Microsoft YaHei, Microsoft YaHei;
                font-weight: 400;
                font-size: 17px;
                color: #FFFFFF;
                line-height: 17px;
                text-align: left;
                font-style: normal;
                text-transform: none;
            }
        }
    }
}

.footer-main {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 185px;
    background-image: url(@/assets/image/apart/apart_footer2.png);
    background-size: cover;
    background-position: center;
    position: relative;

    .footer-img {
        width: 979px;
        height: 88px;

        img {
            height: 100%;
            width: 100%;
            display: block;
        }
    }
}

.tabs {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 400px;
}

textarea {
    box-sizing: border-box;
    height: 100%;
    /* 移除默认的margin */
    // margin: 0;
    width: 100%;
    /* 移除边框 */
    // border: none;

    /* 移除轮廓线（focus时的外边框） */
    outline: none;
    /* 移除默认的内边距 */
    padding: 10px;
    // padding: 0;
    /* 移除背景色 */
    background: transparent;
    /* 禁止调整大小 */
    resize: none;
    /* 移除默认的滚动条样式（WebKit浏览器） */
    -webkit-appearance: none;
    /* 隐藏所有滚动条 */
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE/Edge */
    /* 移除默认的圆角（某些浏览器） */
    border-radius: 0;
    /* 自定义字体 */
    font-family: inherit;
    font-size: inherit;
}

.file-input {
    display: none;
}

.apart-demo {
    // width: 640px;
    // height: 579px;
}
</style>